import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}


/**
 * DelExternalApplicationCB class
 */
export class DelExternalApplicationCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.DelExternalApplication);
    this.i = new I();
    this.o = new O();
  }

}
